module.exports = __webpack_public_path__ + "static/media/mosquito1.dc6563be.jpeg";